













































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, requiredIf } from 'vuelidate/lib/validators'
import Button from '@/app/ui/components/Button/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DateTimePicker from '@/app/ui/components/DateTimePicker/index.vue'
import MultiselectV2 from '@/app/ui/components/MultiselectV2/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import IconWarningTriangle from '@/app/ui/assets/icon_warning_triangles.vue'
import ModalConfirm from '../../../components/Modals/ModalConfirm/index.vue'
import ModalSuccess from '../../../components/Modals/ModalSuccess/index.vue'
import {
  EnumCourierTypeParams,
  EnumOfferMethodType,
  IUpdate,
  IOptions,
  IUpdateDedicated,
} from '@/app/infrastructures/misc/Constants/manageCourierDedicated'
import NestedMultiSelect, {
  ILocation,
} from '../../../components/NestedMultiSelect/index.vue'
import dedicatedController from '@/app/ui/controllers/ManageCourierDedicatedController'
import courierController from '@/app/ui/controllers/ManageCourierController'
import posController from '@/app/ui/controllers/POSController'
import {
  DedicatedCourierItemV2,
  GeoAddress,
  ManageCourierDedicatedDetail,
  ManageCourierDedicatedDetailV2,
} from '@/domain/entities/ManageCourierDedicated'
import { Utils } from '@/app/infrastructures/misc'
import { ManageCourierAdjustSaldo } from '@/domain/entities/ManageCourier'
import IconPlus from '@/app/ui/assets/ics_f_plus_circle.vue'
import { POS } from '@/domain/entities/POS'
import { ManageCourierDedicatedApiRequestV2 } from '@/data/payload/api/ManageCourierDedicatedRequest'
import IconTrash from '@/app/ui/assets/ics_f_trash.vue'
import CheckBox from '@/app/ui/components/CheckBox/index.vue'

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    DropdownSelect,
    TextInput,
    DateTimePicker,
    MultiselectV2,
    LoadingOverlay,
    IconWarningTriangle,
    ModalConfirm,
    ModalSuccess,
    NestedMultiSelect,
    IconPlus,
    IconTrash,
    CheckBox
  },
})
export default class EditAreaDedicatedPage extends Vue {
  dedicatedController = dedicatedController
  courierController = courierController
  posController = posController
  modalConfirmVisible = false
  modalSuccessVisible = false
  courierOptionsMP: Array<IOptions> = []
  courierOptionsCA: Array<IOptions> = []
  courierOptionsClient: Array<IOptions> = []
  courierOptionsCorporateMobil: Array<IOptions> = []
  courierOptionsCorporateMotor: Array<IOptions> = []
  posOptionsMP: Array<IOptions> = []
  posOptionsCA: Array<IOptions> = []
  posOptionsClient: Array<IOptions> = []
  posOptionsCorporateMobil: Array<IOptions> = []
  posOptionsCorporateMotor: Array<IOptions> = []
  geoAddressMainList: Array<ILocation> = []
  existingAreaIds: Array<number> = []

  offerMethodOptions: Array<IOptions> = [
    {
      label: "Auto-Assign",
      value: EnumOfferMethodType.AUTO_ASSIGN,
    },
    { label: "Offer", value: EnumOfferMethodType.OFFER },
  ]

  statusOptions: Array<IOptions> = [
    { label: "Aktif", value: true },
    { label: "Non-Aktif", value: false },
  ]

  hasChanged: Record<string, boolean> = {
    areaName: false,
    location: false,
    offerMethod: false,
    status: false,
  }

  courierParameters = {
    page: 1,
    perPage: 10,
    q: '',
    sortBy: 'ASC',
    driverType: '',
    courierStatus: 'ACTIVE',
  }

  posParameters = {
    page: 1,
    perPage: 10,
    search: '',
    filterStatus: 'ACTIVE',
  }

  geoAddressParameters = {
    search: '',
  }

  form: IUpdate = {
    areaName: '',
    location: [],
    courierMP: [],
    courierCA: [],
    courierClient: [],
    offerMethod: this.offerMethodOptions[-1],
    status: this.statusOptions[-1],
    dedicatedMP: [],
    dedicatedCA: [],
    dedicatedCorporate: [],
    dedicatedCorporateMobil: [],
    dedicatedCorporateMotor: [],
    courierCorporateMobil: [],
    courierCorporateMotor: []
  }

  created(): void {
    this.fetchAreaDedicatedDetail()
    this.fetchMaxConfig()
    this.fetchCourier(true, EnumCourierTypeParams.POS)
    this.fetchPos(true)
  }

  get courierParams(): Record<string, string | number> {
    return { ...this.courierParameters }
  }

  get geoAddressParams(): Record<string, string> {
    return { ...this.geoAddressParameters }
  }

  private fetchMaxConfig(): void {
    this.dedicatedController.getMaxConfig()
  }

  private fetchGeoAddresses(): void {
    this.dedicatedController.getGeoAddress(this.geoAddressParams)
  }

  private fetchCourier(reset?: boolean, driverType?: EnumCourierTypeParams): void {
    if (reset) this.courierParameters.page = 1

    if (driverType === EnumCourierTypeParams.POS) {
      this.courierParameters.driverType = EnumCourierTypeParams.POS
    } else if (driverType === EnumCourierTypeParams.KVP) {
      this.courierParameters.driverType = EnumCourierTypeParams.KVP
    }

    this.courierController.getManageCourierListAdjustSaldo(this.courierParams)
  }

  private fetchPos(reset?: boolean): void {
    if (reset) this.posParameters.page = 1

    this.posController.getPOSData(this.posParameters)
  }

  private fetchAreaDedicatedDetail(): void {
    this.dedicatedController.getDetailV2({id: Number(this.$route.params.id), isShowDetail: true})
  }

  private filterCourier = Utils.debounce(() => {
    this.fetchCourier(true, EnumCourierTypeParams.POS)
  }, 400)

  private filterPos = Utils.debounce(() => {
    this.fetchPos(true)
  }, 400)

  private onAddCourier(field: 'dedicatedMP' | 'dedicatedCA', assignee: string): void {
    this.form[field].push({
      open: false,
      assignee: assignee,
      value: undefined,
      specialHandling: false
    })
  }

  private onDeleteCourier(
    field: 'dedicatedMP' | 'dedicatedCA',
    index: number
  ): void {
    this.form[field].splice(index, 1)
  }

  private onBack(): void {
    this.modalSuccessVisible = false
    this.$router.push('/offer/manage-courier-dedicated')
  }

  private onInputAreaName(): void {
    this.hasChanged.name = true
    dedicatedController.setIsAreaNameExist(false)
  }

  private onChangeMultiselect(value: Array<number>): void {
    this.hasChanged.location = true
    this.form.location = value
  }

  private onCourierSearch(query: string): void {
    this.courierParameters.q = query
    this.filterCourier()
  }

  private onPosSearch(query: string): void {
    this.posParameters.search = query
    this.filterPos()
  }

  private onSubmit(): void {
    this.modalConfirmVisible = false
    let geoIds: Array<number> = []

    this.geoAddressMainList.map(item => {
      if (item.getGeoAddressIds().length !== 0) {
        geoIds.push(...item.getGeoAddressIds().map(id => Number(id)))
      }
    })

    if (!this.$v.form.$invalid) {
      const payload = {
        id: Number(this.$route.params.id),
        data: new ManageCourierDedicatedApiRequestV2({
          area_name: this.form.areaName.trim(),
          geo_address_id: this.form.location,
          dedicated_mp: this.form.dedicatedMP.filter(d => !!d.value?.value).map(d => ({
            ref_id: d.value!.value,
            assignee: d.assignee
          })),
          dedicated_ca: this.form.dedicatedCA.filter(d => !!d.value?.value).map(d => ({
            ref_id: d.value!.value,
            assignee: d.assignee
          })),
          dedicated_client: this.form.dedicatedCorporate.filter(d => !!d.value?.value).map(d => ({
            ref_id: d.value!.value,
            assignee: d.assignee
          })),
          dedicated_corporate_mobil: this.form.dedicatedCorporateMobil.filter(d => !!d.value?.value).map(d => ({
            ref_id: d.value!.value,
            assignee: d.assignee,
            is_special_handling: d.specialHandling
          })),
          dedicated_corporate_motor: this.form.dedicatedCorporateMotor.filter(d => !!d.value?.value).map(d => ({
            ref_id: d.value!.value,
            assignee: d.assignee,
            is_special_handling: d.specialHandling
          })),
          offer_type: <string>this.form.offerMethod.value,
          is_active: <boolean>this.form.status.value,
        })
      }
      this.dedicatedController.updateV2(payload)
    }
  }

  private locationMapper(
    data: GeoAddress,
    existingIds: Array<number>
  ): ILocation {
    return {
      name: data.name || '',
      isChecked: false,
      geoAddressId: data.geoAddressId ? String(data.geoAddressId) : '',
      isParentNotHidden: false,
      setParentNotHidden(state: boolean): void {
        this.children.forEach((child) => {
          child.isParentNotHidden = state
          child.setParentNotHidden(state)
        })
      },
      isNotHidden(keyword: string): boolean {
        const find = (item: ILocation) => item.isNotHidden(keyword)

        if (this.name.toUpperCase().includes(keyword.toUpperCase())) {
          this.setParentNotHidden(true)
          return true
        } else {
          if (this.isParentNotHidden) {
            return true
          } else {
            this.setParentNotHidden(false)
          }
        }

        return (
          this.isParentNotHidden ||
          this.name.toUpperCase().includes(keyword.toUpperCase()) ||
          (this.children && this.children.some(find))
        )
      },
      isDisabled(): boolean {
        if (
          data.areaId &&
          data.geoAddressId &&
          data.areaId !== 0 &&
          !existingIds.includes(Number(data.geoAddressId))
        ) {
          return true
        } else if (data.children && data.children.length !== 0) {
          let childDisabledCount = 0

          this.children.forEach(child => {
            if (child.isDisabled()) {
              childDisabledCount++
            }
          })

          if (childDisabledCount === this.children.length) {
            return true
          }
        }

        return false
      },
      getGeoAddressIds(): Array<number> {
        if (this.isChecked && !this.isDisabled()) {
          if (data.geoAddressId && data.geoAddressId !== 0) {
            return [data.geoAddressId]
          } else if (data.children && data.children.length !== 0) {
            let geoIds: Array<number> = []

            this.children.forEach(child => {
              geoIds.push(...child.getGeoAddressIds())
            })

            return geoIds
          }
        } else if (data.children && data.children.length !== 0) {
          let geoIds: Array<number> = []

          this.children.forEach(child => {
            geoIds.push(...child.getGeoAddressIds())
          })

          return geoIds
        }

        return []
      },
      setIsChecked(state: boolean): void {
        this.isChecked = state
      },
      setCheckedNested(state: boolean): void {
        this.isChecked = state

        if (this.children.length !== 0) {
          this.children.forEach(item => {
            item.setCheckedNested(state)
          })
        }
      },
      children: data.children
        ? data.children.map(child => {
            return this.locationMapper(child, existingIds)
          })
        : [],
    }
  }

  private setLocationState(
    locData: Array<ILocation>,
    idList: Array<number>
  ): void {
    locData.forEach(location => {
      if (
        location.geoAddressId &&
        idList.includes(Number(location.geoAddressId))
      ) {
        location.setIsChecked(true)

        if (location.children.length !== 0) {
          location.setCheckedNested(true)
        }
      }

      if (location.children.length !== 0) {
        this.setLocationState(location.children, idList)
      }
    })
  }

  private checkSelectedOption(data: IOptions): boolean {
    return !(data === undefined || data.value === undefined)
  }

  private onCloseSelect(field: 'dedicatedMP', index: number) {
    this.form[field][index].open = false;
    if (this.form[field][index].assignee === "POS") {
      this.fetchPos(true);
    } else {
      this.fetchCourier(true, EnumCourierTypeParams.POS)
    }
  }

  private onOpenSelect(field: 'dedicatedMP', index: number) {
    this.form[field][index].open = true;
  }

  private mapLabel(item: DedicatedCourierItemV2) {
    if (item.assignee === 'POS') {
      return `${item.posName} [${item.posCode}]`
    }

    return `[${item.id}] ${item.name} (${item.courierType}) ${item.phone} ${item.posName ? `• ${item.posName}` : ""}`
  }

  @Validations()
  validations(): Record<string, unknown> {
    return {
      form: {
        areaName: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(50),
        },
        location: { required },
        offerMethod: {
          isNotEmpty: (value: IOptions) => this.checkSelectedOption(value),
        },
        status: {
          isNotEmpty: (value: IOptions) => this.checkSelectedOption(value),
        },
        dedicatedMP: {
          $each: {
            value: {
              value: {
                required: requiredIf((field: IOptions) => {
                  if (!field) return true
                  return false
                })
              }
            }
          }
        },
        dedicatedCA: {
          $each: {
            value: {
              value: {
                required: requiredIf((field: IOptions) => {
                  if (!field) return true
                  return false
                })
              }
            }
          }
        },
        dedicatedCorporate: {
          $each: {
            value: {
              value: {
                required: requiredIf((field: IOptions) => {
                  if (!field) return true
                  return false
                })
              }
            }
          }
        },
        dedicatedCorporateMobil: {
          $each: {
            value: {
              value: {
                required: requiredIf((field: IOptions) => {
                  if (!field) return true
                  return false
                })
              }
            }
          }
        },
        dedicatedCorporateMotor: {
          $each: {
            value: {
              value: {
                required: requiredIf((field: IOptions) => {
                  if (!field) return true
                  return false
                })
              }
            }
          }
        },
      },
    }
  }

  @Watch('courierController.manageCourierAdjustSaldoData')
  setManageCourierData(data: Array<ManageCourierAdjustSaldo>): void {
    const resultMP: Array<{ label: string; value: number }> = []
    const resultCA: Array<{ label: string; value: number }> = []
    const resultClient: Array<{ label: string; value: number }> = []
    const resultCorporateMobil: Array<{ label: string; value: number }> = []
    const resultCorporateMotor: Array<{ label: string; value: number }> = []
    let existingIdsMP: Array<number> = []
    let existingIdsCA: Array<number> = []
    let existingIdsClient: Array<number> = []
    let existingIdsCorporateMobil: Array<number> = []
    let existingIdsCorporateMotor: Array<number> = []

    this.form.dedicatedMP.filter(item => !!item.value?.value).forEach(item => {
      if (item) existingIdsMP.push(<number>item.value!.value)
    })

    this.form.dedicatedCA.filter(item => !!item.value?.value).forEach(item => {
      if (item) existingIdsCA.push(<number>item.value!.value)
    })

    this.form.dedicatedCorporate.filter(item => !!item.value?.value).forEach(item => {
      if (item) existingIdsClient.push(<number>item.value!.value)
    })

    this.form.dedicatedCorporateMobil.filter(item => !!item.value?.value).forEach(item => {
      if (item) existingIdsCorporateMobil.push(<number>item.value!.value)
    })

    this.form.dedicatedCorporateMotor.filter(item => !!item.value?.value).forEach(item => {
      if (item) existingIdsCorporateMotor.push(<number>item.value!.value)
    })

    data.forEach((courier: ManageCourierAdjustSaldo) => {
      if (courier.courierId && !existingIdsMP.includes(courier.courierId)) {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        if (label && value) {
          resultMP.push({
            label: label,
            value: value,
          })
        }
      }

      if (courier.courierId && !existingIdsCA.includes(courier.courierId)) {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        if (label && value) {
          resultCA.push({
            label: label,
            value: value,
          })
        }
      }

      if (courier.courierId && !existingIdsClient.includes(courier.courierId)) {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        if (label && value) {
          resultClient.push({
            label: label,
            value: value,
          })
        }
      }

      if (courier.courierId && !existingIdsCorporateMobil.includes(courier.courierId)) {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        if (label && value) {
          resultCorporateMobil.push({
            label: label,
            value: value,
          })
        }
      }

      if (courier.courierId && !existingIdsCorporateMotor.includes(courier.courierId)) {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        if (label && value) {
          resultCorporateMotor.push({
            label: label,
            value: value,
          })
        }
      }
    })

    if (this.courierParameters.driverType === EnumCourierTypeParams.POS) {
      this.courierOptionsMP = resultMP
      this.courierOptionsCA = resultCA
      this.courierOptionsClient = resultClient
      this.courierOptionsCorporateMobil = resultCorporateMobil
      this.courierOptionsCorporateMotor = resultCorporateMotor
      this.fetchCourier(true, EnumCourierTypeParams.KVP)
    } else if (
      this.courierParameters.driverType === EnumCourierTypeParams.KVP
    ) {
      this.courierOptionsMP.push(...resultMP)
      this.courierOptionsCA.push(...resultCA)
      this.courierOptionsClient.push(...resultClient)
      this.courierOptionsCorporateMobil.push(...resultCorporateMobil)
      this.courierOptionsCorporateMotor.push(...resultCorporateMotor)
      this.courierParameters.driverType = ''
    }
  }

  @Watch('posController.posData')
  setManagePosData(data: POS[]): void {
    const existingIdsMP = this.form.dedicatedMP.filter(pos => !!pos?.value?.value && pos.assignee === 'POS').map((pos) => pos.value!.value);
    const existingIdsCA = this.form.dedicatedCA.filter(pos => !!pos?.value?.value && pos.assignee === 'POS').map((pos) => pos.value!.value);
    const existingIdsClient = this.form.dedicatedCorporate.filter(pos => !!pos?.value?.value && pos.assignee === 'POS').map((pos) => pos.value!.value);
    const existingIdsCorporateMobil = this.form.dedicatedCorporateMobil.filter(pos => !!pos?.value?.value && pos.assignee === 'POS').map((pos) => pos.value!.value);
    const existingIdsCorporateMotor = this.form.dedicatedCorporateMotor.filter(pos => !!pos?.value?.value && pos.assignee === 'POS').map((pos) => pos.value!.value);

    this.posOptionsMP = data.filter(pos => !existingIdsMP.includes(pos.id)).map((pos) => ({
      label: `${pos.name} [${pos.code}]`,
      value: pos.id,
    }))

    this.posOptionsCA = data.filter(pos => !existingIdsCA.includes(pos.id)).map((pos) => ({
      label: `${pos.name} [${pos.code}]`,
      value: pos.id,
    }))

    this.posOptionsClient = data.filter(pos => !existingIdsClient.includes(pos.id)).map((pos) => ({
      label: `${pos.name} [${pos.code}]`,
      value: pos.id,
    }))

    this.posOptionsCorporateMobil = data.filter(pos => !existingIdsCorporateMobil.includes(pos.id)).map((pos) => ({
      label: `${pos.name} [${pos.code}]`,
      value: pos.id,
    }))

    this.posOptionsCorporateMotor = data.filter(pos => !existingIdsCorporateMotor.includes(pos.id)).map((pos) => ({
      label: `${pos.name} [${pos.code}]`,
      value: pos.id,
    }))
  }

  @Watch('dedicatedController.dataGeoAddressList')
  setGeoAddressData(data: Array<GeoAddress>): void {
    if (data) {
      const mapRes: Array<ILocation> = data.map(
        (item): ILocation => {
          return this.locationMapper(item, this.existingAreaIds)
        }
      )

      this.geoAddressMainList = mapRes

      this.setLocationState(this.geoAddressMainList, this.form.location)
    }
  }

  @Watch('dedicatedController.dataManageCourierDedicatedDetailV2')
  setDedicatedDetailData(data: ManageCourierDedicatedDetailV2): void {
    let dedicatedMp: Array<IUpdateDedicated> = []
    let dedicatedCa: Array<IUpdateDedicated> = []
    let dedicatedCorporate: Array<IUpdateDedicated> = []
    let dedicatedCorporateMobil: Array<IUpdateDedicated> = []
    let dedicatedCorporateMotor: Array<IUpdateDedicated> = []

    if (data.dedicatedMp) {
      dedicatedMp = data.dedicatedMp.map(item => {
        return {
          open: false,
          value: {
            label: this.mapLabel(item),
            value: item.id
          },
          assignee: item.assignee,
          specialHandling: false
        }
      })
    }

    if (data.dedicatedCa) {
      dedicatedCa = data.dedicatedCa.map(item => {
        return {
          open: false,
          value: {
            label: this.mapLabel(item),
            value: item.id
          },
          assignee: item.assignee,
          specialHandling: false
        }
      })
    }

    if (data.dedicatedCorporate) {
      dedicatedCorporate = data.dedicatedCorporate.map(item => {
        return {
          open: false,
          value: {
            label: this.mapLabel(item),
            value: item.id
          },
          assignee: item.assignee,
          specialHandling: false
        }
      })
    }

    if (data.dedicatedCorporateCar) {
      dedicatedCorporateMobil = data.dedicatedCorporateCar.map(item => {
        return {
          open: false,
          value: {
            label: this.mapLabel(item),
            value: item.id
          },
          assignee: item.assignee,
          specialHandling: item.isSpecialHandling
        }
      })
    }

    if (data.dedicatedCorporateMotorcycle) {
      dedicatedCorporateMotor = data.dedicatedCorporateMotorcycle.map(item => {
        return {
          open: false,
          value: {
            label: this.mapLabel(item),
            value: item.id
          },
          assignee: item.assignee,
          specialHandling: item.isSpecialHandling
        }
      })
    }


    const res: IUpdate = {
      areaName: data.areaName || '',
      location: data.geoAddressIds ? data.geoAddressIds : [],
      courierMP: [],
      courierCA: [],
      courierClient: [],
      courierCorporateMobil: [],
      courierCorporateMotor: [],
      offerMethod:
        this.offerMethodOptions.find(item => item.value === data.offerType) ||
        this.offerMethodOptions[-1],
      status: data.isActive ? this.statusOptions[0] : this.statusOptions[1],
      dedicatedMP: dedicatedMp,
      dedicatedCA: dedicatedCa,
      dedicatedCorporate: dedicatedCorporate,
      dedicatedCorporateMobil: dedicatedCorporateMobil,
      dedicatedCorporateMotor: dedicatedCorporateMotor
    }

    this.form = res

    if (data.geoAddressIds) {
      this.existingAreaIds = data.geoAddressIds
      this.form.location = data.geoAddressIds
    }

    this.fetchGeoAddresses()
  }

  @Watch('form.areaName')
  onChangeAreaName(data: string): void {
    // remove script tags
    this.form.areaName = Utils.removeScriptTags(data)

    // remove special characters
    this.form.areaName = Utils.removeSpecialCharacters(this.form.areaName)

    // remove html tags
    this.form.areaName = Utils.removeHTMLTags(this.form.areaName)
  }

  @Watch('dedicatedController.isSuccessEditManageCourierDedicated')
  onSuccessEdit(value: boolean): void {
    if (value) {
      this.modalSuccessVisible = true
    }
  }

  beforeDestroy(): void {
    dedicatedController.setIsAreaNameExist(false)
    dedicatedController.setIsSuccessEditManageCourierDedicated(false)
  }
}
